import React, {Component} from 'react';
import PieChartWithTable from './PieChartWithTable';

export default class TendersVsDANumber extends Component {
    render() {
        return (
            <PieChartWithTable
                title={window.__js_dashboard.tenders_vs_da_number}
                data={this.props.data}
                hasIntegerValues={true}
            />
        );
    }
}
